
/**
 * Load required plugin.
 */
require('jquery.photoswipe/dist/jquery.photoswipe-global.js');


/**
 * Configure the plugin.
 */

+function($){
  page.registerVendor('PhotoSwipe');

  page.initPhotoSwipe = function() {
    $('[data-provide="photoswipe"]').each(function() {
      var tag = $(this),
          selector = tag.dataAttr('photoswipe-selector', '.gallery-item');

      $(tag).photoSwipe(selector);
    });
  }

}(jQuery);





//////////////////
// WEBPACK FOOTER
// ./assets/plugin/thesaas/js/vendors/photoswipe.js
// module id = 54
// module chunks = 0